module.exports = __webpack_public_path__ + "img/ic_dialog_bed.ce2eb27b.png";